import styled from 'styled-components';
import { Button, Icon, IconButton } from '@wistia/vhs';
import type { JSX } from 'react';
import type { Size } from './types';

const StyledIconButton = styled(IconButton)<{ $bgIsTransparent: boolean }>`
  background-color: ${({ $bgIsTransparent }) => ($bgIsTransparent ? 'transparent' : '#fff')};
  position: absolute;
  right: ${({ theme }) => theme.spacing.space02};
  top: ${({ theme }) => theme.spacing.space02};
`;

type BannerCloseButtonProps = {
  /**
   * Callback invoked when the button is clicked
   */
  onClick: () => void;

  size?: Size;

  colorOverride?: string;

  bgIsTransparent: boolean;
};

export const BannerCloseButton = ({
  onClick,
  size,
  colorOverride,
  bgIsTransparent,
}: BannerCloseButtonProps): JSX.Element => {
  if (size === 'sm') {
    return (
      <Button
        variant="secondary"
        size={size}
        label="Dismiss"
        onClick={onClick}
        colorOverride={colorOverride}
      />
    );
  }

  return (
    <StyledIconButton
      aria-label="Dismiss"
      icon={
        <Icon
          size="sm"
          type="close"
        />
      }
      onClick={onClick}
      preventTooltip={true}
      colorOverride={colorOverride}
      $bgIsTransparent={bgIsTransparent}
    />
  );
};
